<dx-load-panel
  [hideOnOutsideClick]="false"
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingIndicator">
</dx-load-panel>

<div class="form-grid-container mt-3">
  <div>
    <form [formGroup]="requestForm">
      <ng-container class="row mt-3" formArrayName="sections">
        <ng-container *ngFor="let section of sectionsArray.controls; let sectionIndex = index">
          <ng-container [formGroupName]="sectionIndex">
            <mat-slide-toggle
              class="float-left"
              color="primary"
              (change)="toggleStock('previous', $event)"
              *ngIf="showPreviousStock">
              Previous Stock
            </mat-slide-toggle>

            <dx-button
              id="add-row"
              text="Add Rows"
              *ngIf="showAddRowBtn"
              type="normal"
              class="float-right"
              (click)="addRows()">
            </dx-button>

            <span class="total-count" *ngIf="totalToggle">Total: {{ getTotal }}</span>
            <div class="clearfix"></div>

            <div class="row mt-2" *ngIf="getCxTypeDetail(section)?.length">
              <div class="col">
                <div class="card animated fadeIn">
                  <div class="card-body pb-0">
                    <dx-data-grid
                      class="inventory-cx-grid"
                      [dataSource]="getCxTypeDetail(section)"
                      [columnAutoWidth]="true"
                      [hoverStateEnabled]="true"
                      [rowAlternationEnabled]="true"
                      [showBorders]="true"
                      [wordWrapEnabled]="true">

                      <dxi-column caption="S#." width="60" alignment="center" cellTemplate="serialCell"></dxi-column>
                      <dxi-column caption="CX Type" [minWidth]="140" cellTemplate="cxTypeCell"></dxi-column>
                      <dxi-column caption="Bar Code" [minWidth]="200" cellTemplate="barcodeCell"></dxi-column>
                      <dxi-column caption="Qty" width="100" alignment="center" cellTemplate="qtyCell"></dxi-column>
                      <dxi-column caption="CX" width="90" alignment="center" cellTemplate="cxCell"></dxi-column>
                      <dxi-column caption="TC" width="90" alignment="center" cellTemplate="tcCell"></dxi-column>
                      <dxi-column caption="CC" width="90" alignment="center" cellTemplate="ccCell"></dxi-column>
                      <dxi-column caption="CT" width="90" alignment="center" cellTemplate="ctCell"></dxi-column>
                      <dxi-column caption="ET" width="90" alignment="center" cellTemplate="etCell"></dxi-column>
                      <dxi-column caption="ADD" width="90" alignment="center" cellTemplate="addCell"></dxi-column>
                      <dxi-column *ngIf="showWt" caption="WT" width="90" alignment="center" cellTemplate="wtCell"></dxi-column>
                      <dxi-column caption="Remarks" [minWidth]="200" cellTemplate="remarkCell"></dxi-column>
                      <dxi-column caption="Action" width="90" alignment="center" cellTemplate="actionCell"></dxi-column>

                      <div *dxTemplate="let cell of 'serialCell'">
                        {{ getAbsoluteRowIndex(cell) + 1 }}
                      </div>

                      <div *dxTemplate="let cell of 'cxTypeCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <select class="form-control-sm w-100" formControlName="cxtypeId" disabled>
                              <option value="">Select Cx Type</option>
                              <option *ngFor="let cx of cxList" [value]="cx.cxtypeId">
                                {{ cx.cxtypeName }}
                              </option>
                            </select>
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'barcodeCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              *ngIf="!rowForm.get('isBarCodeEnable').value"
                              type="text"
                              formControlName="vendorItemCode"
                              SignNotAllowed="-"
                              class="form-control form-control-sm hvr-glow animated fadeInRight w-200"
                              [readonly]="readonly"
                              autocomplete="off" />
                            <input
                              *ngIf="rowForm.get('isBarCodeEnable').value"
                              type="text"
                              formControlName="vendorItemCode"
                              SignNotAllowed="-"
                              class="form-control form-control-sm hvr-glow animated fadeInRight w-200"
                              autocomplete="off"
                              (focusout)="getCatalogByBarcode(rowForm.get('vendorItemCode').value, getAbsoluteRowIndex(cell))" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'qtyCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              [attr.tabindex]="getAbsoluteRowIndex(cell) + 1"
                              SignNotAllowed="{{ inputType ? '' : '101' }}"
                              type="text"
                              NumberValidate
                              formControlName="qty"
                              [readonly]="!rowForm.get('vendorItemCode').value || acknowledgement"
                              SignNotAllowed="-"
                              min="0"
                              class="form-control form-control-sm hvr-glow animated fadeInRight text-center"
                              autocomplete="off" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'cxCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              type="number"
                              formControlName="cx"
                              class="form-control form-control-sm hvr-glow animated fadeInRight text-center"
                              [readonly]="readonly"
                              autocomplete="off" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'tcCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              type="number"
                              min="0"
                              SignNotAllowed="-"
                              formControlName="tc"
                              class="form-control form-control-sm hvr-glow animated fadeInRight text-center"
                              [readonly]="readonly"
                              autocomplete="off" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'ccCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              type="number"
                              min="0"
                              SignNotAllowed="-"
                              formControlName="cc"
                              class="form-control form-control-sm hvr-glow animated fadeInRight text-center"
                              [readonly]="readonly"
                              autocomplete="off" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'ctCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              type="number"
                              min="0"
                              SignNotAllowed="-"
                              formControlName="ct"
                              class="form-control form-control-sm hvr-glow animated fadeInRight text-center"
                              [readonly]="readonly"
                              autocomplete="off" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'etCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              type="number"
                              min="0"
                              SignNotAllowed="-"
                              formControlName="et"
                              class="form-control form-control-sm hvr-glow animated fadeInRight text-center"
                              [readonly]="readonly"
                              autocomplete="off" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'addCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              type="number"
                              min="0"
                              SignNotAllowed="-"
                              formControlName="add"
                              class="form-control form-control-sm hvr-glow animated fadeInRight text-center"
                              [readonly]="readonly"
                              autocomplete="off" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'wtCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              type="number"
                              min="0"
                              SignNotAllowed="-"
                              formControlName="wt"
                              class="form-control form-control-sm hvr-glow animated fadeInRight text-center"
                              [readonly]="readonly"
                              autocomplete="off" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'remarkCell'">
                        <ng-container *ngIf="getCxRow(sectionIndex, getAbsoluteRowIndex(cell)) as rowForm">
                          <div [formGroup]="rowForm">
                            <input
                              type="text"
                              id="comment-{{ getAbsoluteRowIndex(cell) }}"
                              (input)="showRemarks(section, getAbsoluteRowIndex(cell))"
                              (focus)="showRemarks(section, getAbsoluteRowIndex(cell))"
                              formControlName="remarks"
                              [readonly]="readonly"
                              class="form-control form-control-sm hvr-glow animated fadeInRight"
                              autocomplete="off" />
                          </div>
                        </ng-container>
                      </div>

                      <div *dxTemplate="let cell of 'actionCell'">
                        <a href="javascript:void(0)" class="cursor-pointer warn">
                          <mat-icon (click)="removeIndex(getAbsoluteRowIndex(cell))">delete_forever</mat-icon>
                        </a>
                      </div>
                    </dx-data-grid>
                  </div>
                </div>
              </div>
            </div>

            <dx-popover
              position="top"
              [width]="150"
              [showTitle]="true"
              title="Remarks Preview"
              [(visible)]="actionSheetVisible"
              [target]="popupTarget"
              [hideOnOutsideClick]="true">
              <div *dxTemplate="let data = model of 'content'">
                {{ userRemarks }}
              </div>
            </dx-popover>

            <div class="row mt-2">
              <div class="col animated fadeInUp" *ngIf="validateSubmitBtn">
                <dx-button
                  id="button"
                  [disabled]="loadingIndicator"
                  [text]="isEdit ? 'Update' : 'Save'"
                  type="default"
                  class="float-right ml-3"
                  (click)="!requestForm.valid || saveStockRequest(requestForm)"
                  [useSubmitBehavior]="true">
                </dx-button>
                <dx-button
                  text="Cancel"
                  type="normal"
                  class="float-right"
                  appBackButton>
                </dx-button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </form>
  </div>
</div>
